const queryKeys = Object.freeze({
  example: "example",
  getProjectList: "projects",
  getProjectDetail: "project",
  getListComponents: "components",
  getListLicensePolicy: "license_policies",
  getListLicenseAttributes: "license_attributes",
  licensePolicyExport: "license_policy_export",
  licensePolicyImport: "license_policy_import",
  vulnerabilityPolicyExport: "vulnerability_policy_export",
  vulnerabilityPolicyImport: "vulnerability_policy_import",
  vulnerabilityPolicy: "vulnerability_policy",
  vulnerabilityPolicies: "vulnerability_policies",
  getVulnerabilityPolicies: "vulnerability_policies",
  getComponentById: "component",
  getComponentLicensePeriods: "component_license_periods",
  updateComponent: "component",
  addComponent: "component",
  deleteComponents: "components",
  users: "users",
  licenseAttribute: "license_attributes",
  getListLicenses: "licenses",
  getLicenseById: "license",
  addLicense: "license",
  updateLicense: "license",
  deleteLicenses: "licenses",
  fileInfo: "file_info_by_file_group_no",
  getComponentUsageData: "status_component_usages",
  getComponentUsageInformation: "status_scan_component",
  binaryVerificationByProjectSeq: "binary_verification_by_project_seq",
  binaryVerification: "binary_verification",
  sourceCodeVerificationByProjectSeq: "source_code_verification_by_project_seq",
  sBOMVerificationByProjectSeq: "sbom_verification_by_project_seq",
  getVulnerabilityStatus: "vulnerability_statuses",
  getLicenseUsageData: "status_license_usages",
  getLicenseUsageInformation: "status_scan_component",
  getCVEStatusList: "cves",
  getCVEStatusDetail: "cve",
  getCveAnalysisList: "cve_analysis",
  getCveAnalysisDetail: "cve_analysis",
  getComponentCVEStatusList: "component_cves",
  getBinaryInformationById: "binary_information",
  getProjectByProjectId: "project",
  getLicensePolicyByLicenseId: "license_policy",
  getClarityById: "clarity",
  getFileInfoByFileGroupNo: "file_info",
  getBinaryScanComponentsByProjectSeq: "binary_scan_components",
  getBinaryScanComponentByProjectSeqAndVerificationVersion: "binary_scan_component",
  updateBinaryVerificationApprovalRequestFlag: "binary_verification_approval_request_flag",
  updateBinaryVerificationApprovalFlag: "binary_verification_approval_flag",
  getAnnouncementList: "bulletins",
  deleteAnnouncement: "bulletins",
  addAnnouncement: "bulletin",
  getAnnouncementById: "bulletin",
  updateAnnouncement: "bulletin",
  getFileInfo: "file_info_by_file_group_no",
  increaseViewCountAnnouncement: "bulletin_view_cnt_up",
  getDistributionScopes: "distribution_scopes",
  uploadFiles: "file_group_upload",
  getLicensePolicyList: "license_policies",
  getUserDataByUserId: "user",
  getSBOMList: "sboms",
  createBinaryVerification: "binary_verification",
  createSourceCodeVerification: "source_code_verification",
  updateSourceCodeVerification: "source_code_verification",
  createSbomVerification: "sbom_verification",
  detectSbomFormat: "sbom_verification/detect",
  downloadSbomExcelTemplate: "sbom_verification/excel_template",
  binaryVerificationUpload: "binary_verification_upload",
  sourceCodeVerificationUpload: "source_code_verification_upload",
  sbomVerificationUpload: "sbom_verification_upload",
  binaryVerificationStatus: "binary_verification",
  sourceCodeVerificationStatus: "source_code_verification",
  getAssetClassifications: "asset_classifications",
  updateProject: "project",
  updateProjectPreviewLink: "project",
  createProject: "project",
  removeProject: "projects",
  getUserList: "users",
  getUserById: "user",
  getMyProfile: "my_profile",
  registerUser: "register",
  searchInfos: "search_infos",
  getSbomBySeq: "sbom",
  getSbomList: "sboms",
  updateSbomList: "sboms",
  deleteSboms: "sboms",
  deleteSingleSbom: "sbom",
  getCodeListForSbom: "sbom_item_types",
  getRoleList: "role_codes",
  updateRoleList: "role_codes",
  getCodeListForRole: "permission_codes",
  getWorkHistoryList: "work_histories",
  getWorkHistoryBySeq: "work_history",
  getPreferencesData: "preferences",
  getClientConfig: "client-config",
  clarityScanPreferences: "preferences/clarity-scan",
  getLocaleLanguage: "locale_default",
  getAssetClassification: "asset_classifications",
  importProjectFromFossid: "import_project_from_fossid",
  importProjectFlag: "import_project_flag",
  genesisSyncStart: "genesis-sync/start",
  genesisSyncFull: "genesis-sync/full",
  genesisSyncStreamStart: (stream) => `genesis-sync/${stream}/start`,
  genesisSyncStreamFull: (stream) => `genesis-sync/${stream}/full`,
  genesisSyncStatus: "genesis-sync/status",
  getSourceCodeScanDependencyByProjectIdAndVerificationVersion: "source_code_scan_dependency",
  getSourceCodeActionBySourceCodeVerificationSeq: "source_code_action",
  getLicensePolicyByLicensePolicySeq: "license_policy_Seq",
  getBinaryVerificationByProjectId: "binary_verification_by_project_id",
  getBinaryVerificationCompareWithSbomVerification: "sbom_verification_compare_to_binary",
  getSearchInfosList: "search_infos",
  getActionList: "/actions",
  getActionById: "/action",
  getVerificationReportList: "verification_reports",
  addVerificationReport: "verification_report",
  deleteVerificationReports: "verification_reports",
  getVerificationReportByVerificationReportSeq: "verification_report_by_verification_report_seq",
  getProjectById: "project_by_project_id",
  getBinaryVerifications: "binary_verifications",
  getSourceCodeVerificationsWithClarity: "source_code_verification_with_clarity",
  getSourceCodeVerifications: "source_code_verifications",
  getVerificationProject: "verification_project",
  getNoticeInfosProject: "notice_infos",
  deleteNoticeInfos: "notice_infos",
  getNoticeInfo: "notice_info",
  getVerificationReportBySeq: "verification_report",
  updateNoticeInfoNoticeInfoWriteStatus: "notice_info_notice_info_write_status",
  getdNoticeInfoComponentsByNoticeInfoSeq: "notice_info_component_by_notice_info_seq",
  updateNoticeInfoStatus: "notice_info_status",
  noticeInfoDownloadText: "noticeInfoDownloadText",
  noticeInfoDownloadHtml: "noticeInfoDownloadHtml",
  getSbomMergedList: "/merged_sboms",
  getSbomMerged: "merged_sbom",
  deleteSbomMergeds: "/merged_sboms",
  exportSbomMerged: "mergedSbomDownload",
  getQnaList: "qnas",
  getQnaById: "qna",
  updateQna: "qna",
  deleteQna: "qnas",
  addQna: "qna",
  getQAList: "qnas",
  getQAById: "qna",
  updateQA: "qna",
  deleteQA: "qnas",
  addQA: "qna",
  increaseViewCountQA: "qna_view_cnt_up",
  getFaqList: "faqs",
  getFaqById: "faq",
  updateFaq: "faq",
  deleteFaq: "faqs",
  addFaq: "faq",
  getArchiveList: "archives",
  getArchiveById: "archive",
  updateArchive: "archive",
  deleteArchive: "archives",
  addArchive: "archive",
  updateAnswer: "qna_answer",
  increaseViewCountQna: "qna_view_cnt_up",
  increaseViewCountFaq: "faq_view_cnt_up",
  increaseViewCountArchive: "archive_view_cnt_up",
  getFulfillmentProcessList: "fulfillment",
  getProjectPreviews: "project_previews",
  getUserList: "users",
  deleteProjectPreviews: "project_previews",
  getProjectPreview: "project_preview",
  createProjectPreview: "project_preview",
  licenseAttributeByLicenseIdentifier: "license_attribute_by_license_identifier",
  licenseAttributeByLicenseIdentifierBatch: "license_attribute_by_license_identifier/batch",
  updateProjectPreview: "project_preview",
  getLicensePolicy: "license_policy",
  createLicensePolicy: "license_policy",
  deleteLicensePolicy: "license_policy",
  getImportComponentsList: "import_components",
  getImportComponentBySeq: "import_component",
  updateImportComponent: "import_component",
  importComponentForDisabled: "import_component_for_disabled",
  importComponentForApprove: "import_component_for_approval",
  importComponentForScan: "import_component_for_scan",
  deleteImport: "import_components",
  getProjectVerificationData: "merged_verification",
  getProjectPreviewComponentByProjectPreviewSeq: "project_preview_component_by_project_preview_seq",
  getBinaryScanComponent: "binary_scan_component",
  getSourceCodeScanComponent: "source_code_scan_component",
  getSbomScanComponent: "sbom_scan_component",
  getBinaryScanComponent: "binary_scan_component",
  getSbomScanComponent: "sbom_scan_component",
  exportVerificationComparison: "verificationComparisonDownload",
  getComponentDataFromProjectIdAndVerificationVersion: "",
  createSbomMerged: "merged_sbom",
  updateSbomMerged: "merged_sbom",
  getMergedSbomsVerificationFiles: "merged_sboms_verification_files",
  checkDuplicateVerificationUpload: "check_duplicate_verification_upload",
  licensePoliciesForProject: "license_policies_for_project",
  getProjectPreviewComponentByProjectPreviewSeqWithPagination: "project_preview_components",
  getMembersByProjectId: "project_members_by_project_id",
  projectMembers: "project_members",
  getSourceCodeScanComponentByProjectIdAndVerificationVersion: "source_code_scan_component",
  getFossidById: "source_code_verification",
  downloadVerificationReportSbom: "verificationReportDownloadSbom",
  verificationReportSbomReadableView: "verificationReportSbomReadableView",
  mergedSbomReadableView: "mergedSbomReadableView",
  productReportSbomReadableView: "productReportSbomReadableView",
  groupProductReportSbomReadableView: "groupProductReportSbomReadableView",
  binaryAction: "binary_action",
  getProductDetail: "product",
  getProjectsByProduct: "project_by_product",
  getListProducts: "products",
  myProducts: "my_products",
  myProductsWithRole: "my-products-with-role",
  createProduct: "product",
  updateProduct: "product",
  deleteUser: "user",
  updateUser: "user",
  changeOwnPassword: "my_profile/password",
  resetUserPassword: (userId) => `user/${userId}/password`,
  getBulletinListForPopup: "bulletin_list_for_popup",
  getProjectsWithVerification: "get_project_with_verification",
  aboutInfo: "about",
  licensePoliciesOnly: "license_policies_only",
  importProjectStatuses: "import_project_statuses",
  // System endpoints
  checkUpdates: "check-updates",
  triggerUpdate: "trigger-update",
  updateStatus: "update-status",
  getUpdateSummary: "last-update-summary",
  acknowledgeUpdateSummary: "last-update-summary/acknowledge",
  getSearchCreatorList: "user_creators",
  activeUsers: "active_users",
  getClarityAirWorkSpaceList: "clarity_air_workspaces",
  clarityAirVerificationByProjectSeq: "clarity_air_verification_by_project_seq",
  createClarityAirVerification: "clarity_air_verification",
  clarityAirVerificationUpload: "clarity_air_verification_upload",
  getClarityAirById: "clarity_air_verification",
  getClarityAirActionBySeq: "clarity_air_action",
  getClarityAirScanComponentBySeq: "clarity_air_scan_components",
  getClarityAirScanDependencyBySeq: "clarity_air_scan_dependency",
  getClarityAirScanFollowupPlanBySeq: "clarity_air_scan_followup_plan",
  vexList: "vex",
  vexProgress: "vex_progress",
  vexDetail: "vex_detail",
  vexImport: "vex_import",
  vexImportSources: "vex_import_sources",
  vexVersionAnalysis: "vex_version_analysis",
  vexSnapshot: "vex_snapshot",
  getSyncMetadata: "sync/metadata",
});

export default queryKeys;
